import React from "react";
import { useHistory, useLocation } from "react-router-dom";

const AnalyticsNav = () => {
  const location = useLocation();
  const history = useHistory();

  return (
    <div className="analytics-nav">
      <ul>
        {/* <li
          className={location.pathname === "/analytics" ? "active" : ""}
          onClick={() => {
            history.push("/analytics");
          }}
        >
          Summary
        </li> */}
        {/* <li>Users</li> */}
        <li
          className={
            location.pathname === "/analytics/expenses" ? "active" : ""
          }
          onClick={() => {
            history.push("/analytics/expenses");
          }}
        >
          Expenses
        </li>
        <li
          className={location.pathname === "/analytics/reports" ? "active" : ""}
          onClick={() => {
            history.push("/analytics/reports");
          }}
        >
          Expense Reports
        </li>
        {/* <li>Reimbursements</li> */}
        <li
          className={
            location.pathname === "/analytics/trips" ? "active" : ""
          }
          onClick={() => {
            history.push("/analytics/trips");
          }}
        >
          Trips
        </li>
        {/* <li
          className={location.pathname === "/analytics/cards" ? "active" : ""}
          onClick={() => {
            history.push("/analytics/cards");
          }}
        >
          Card Transactions
        </li> */}
        <li
          className={
            location.pathname === "/analytics/advances" ? "active" : ""
          }
          onClick={() => {
            history.push("/analytics/advances");
          }}
        >
          Advances
        </li>
        {/* <li>Activity</li> */}
      </ul>
    </div>
  );
};

export default AnalyticsNav;
